import { NavLink } from "react-router-dom";
import type { ReactNode } from "react";

interface Tab {
  to: string;
  label: string;
  icon: ReactNode;
}

const tabs: Tab[] = [
  { to: "/app/today", label: "Today", icon: <TodayIcon /> },
  { to: "/app/garden", label: "Garden", icon: <GardenIcon /> },
  { to: "/app/sage", label: "Sage", icon: <SageIcon /> },
  { to: "/app/plan", label: "Plan", icon: <PlanIcon /> },
  { to: "/app/journal", label: "Journal", icon: <JournalIcon /> },
];

export function BottomNav() {
  return (
    <nav
      aria-label="Primary"
      className="fixed inset-x-0 bottom-0 flex items-stretch justify-around px-2 pb-[env(safe-area-inset-bottom)] pt-2"
      style={{ background: "#FFFFFF", borderTop: "1px solid #EAE4DA" }}
    >
      {tabs.map((tab) => {
        const isSage = tab.label === "Sage";
        return (
          <NavLink
            key={tab.to}
            to={tab.to}
            className={({ isActive }) =>
              [
                "flex flex-col items-center justify-center text-xs",
                "min-h-[56px] flex-1 max-w-[80px]",
                isActive ? "font-semibold" : "font-normal",
              ].join(" ")
            }
            style={({ isActive }) => ({
              color: isSage ? "#8A4E9C" : isActive ? "#1A1620" : "#9A8A78",
            })}
          >
            <span className={isSage ? "scale-125" : ""} aria-hidden>
              {tab.icon}
            </span>
            <span className="mt-1">{tab.label}</span>
          </NavLink>
        );
      })}
    </nav>
  );
}

function iconProps() {
  return {
    width: 22,
    height: 22,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.75,
    strokeLinecap: "round" as const,
    strokeLinejoin: "round" as const,
  };
}

function TodayIcon() {
  return (
    <svg {...iconProps()}>
      <rect x="3" y="4" width="18" height="18" rx="2" />
      <path d="M16 2v4M8 2v4M3 10h18" />
    </svg>
  );
}
function GardenIcon() {
  return (
    <svg {...iconProps()}>
      <path d="M12 2v20M5 12c0-4 3-6 7-6s7 2 7 6" />
      <path d="M5 18c0-3 3-4 7-4s7 1 7 4" />
    </svg>
  );
}
function SageIcon() {
  return (
    <svg {...iconProps()}>
      <path d="M12 2C7 6 5 10 5 14a7 7 0 0 0 14 0c0-4-2-8-7-12z" />
      <path d="M12 14v6" />
    </svg>
  );
}
function PlanIcon() {
  return (
    <svg {...iconProps()}>
      <path d="M9 11l3 3L22 4" />
      <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" />
    </svg>
  );
}
function JournalIcon() {
  return (
    <svg {...iconProps()}>
      <path d="M4 4h13a3 3 0 0 1 3 3v13a1 1 0 0 1-1 1H6a2 2 0 0 1-2-2z" />
      <path d="M8 8h8M8 12h8M8 16h5" />
    </svg>
  );
}
